export function memoize<T extends () => any>(callback: T): T {
  let cache: any
  let called = false
  let idleCallbackId: null | number = null

  const memoizedFunction = (): ReturnType<T> => {
    if (called) {
      return cache
    }

    cache = callback()
    called = true

    if (idleCallbackId === null) {
      idleCallbackId = requestIdleCallback(() => {
        cache = null
        called = false
        idleCallbackId = null
      })
    }

    return cache
  }

  return memoizedFunction as T
}
